import { toast } from 'react-toastify';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import InfoIcon from '@mui/icons-material/Info';
import Box from '@mui/material/Box';
import { JSX } from 'react';

const ToastContent = (IconComponent: JSX.Element, message: string) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1, 
    }}
  >
    {IconComponent}
    <span>{message}</span>
  </Box>
);

export const notifySuccess = (message: string) => {
  toast.success(ToastContent(<CheckCircleIcon sx={{ color: 'green' }} />, message));
};

export const notifyError = (message: string) => {
  toast.error(ToastContent(<CancelIcon sx={{ color: 'red' }} />, message));
};

export const notifyInfo = (message: string) => {
  toast.info(ToastContent(<InfoIcon sx={{ color: 'blue' }} />, message));
};

// export const notifyWarning = (message: string) => {
//   toast.warning(ToastContent(<WarningIcon sx={{ color: 'orange' }} />, message));
// };